<template>
    <div class="video-player">
        <video
            ref="VideoPlayer"
            class="video-player__video"
            controls
            playsinline
            preload="metadata"
            :poster="poster"
            @play="OnPlay"
            @pause="OnPause"
            @ended="OnEnded"
            @error="OnError"
        >
            <source
                :src="src"
                type="video/mp4"
            />

            Trình duyệt không hỗ trợ video MP4.
        </video>
    </div>
</template>

<script>
export default {
    name: 'Mp4Player',

    props: {
        src: {
            type: String,
            required: true
        },

        poster: {
            type: String,
            default: ''
        }
    },

    methods: {
        Play() {
            const Player =
                this.$refs.VideoPlayer;

            if (!Player) {
                return;
            }

            Player.play().catch(Error => {
                console.log(
                    'Video-Play-Error:',
                    Error
                );
            });
        },

        Pause() {
            const Player =
                this.$refs.VideoPlayer;

            if (Player) {
                Player.pause();
            }
        },

        OnPlay() {
            this.$emit('play');
        },

        OnPause() {
            this.$emit('pause');
        },

        OnEnded() {
            this.$emit('ended');
        },

        OnError(Event) {
            console.log(
                'Video-Error:',
                Event
            );

            this.$emit(
                'error',
                Event
            );
        }
    }
};
</script>

<style scoped>
.video-player {
    width: 100%;
    overflow: hidden;
    background: #000;
    border-radius: 4px;
}

.video-player__video {
    display: block;
    width: 100%;
    max-height: 70vh;
    background: #000;
}
</style>